<template>
	<div class="deal_box">
		<!-- 分割线 -->
		<div class="cut_off"></div>
		<!-- 内容 -->
		<div class="deal_show_box">
			<!-- 左边 deal_left -->
			<div class="deal_left">
				<!-- 用户头像区块 -->
				<div class="deal_user">
					<div class="deal_user_photo">
						<img src="../../../assets/img/common/photo_replace.png" alt="">
					</div>
					<div class="deal_user_name">{{this.$store.state.storename}}</div>
					<div class="deal_user_id">UID：{{this.$store.state.uid}}</div>
					<!-- deal_user -->
				</div>
				<!-- 下拉菜单 -->
				<div class="drop_down_box">
					<!-- 個人設定 -->
					<div class="drop_box drop_management" :class="showst==1?'drop_active':''"  @click="downShows(1)">
						<div class="drop_down_title drop_down_hehi" >
							<img src="../../../assets/img/user/03my_product.png" alt="">產品目錄<i :class="showst==1?'el-icon-arrow-up':'el-icon-arrow-down'" ></i>
						</div>
						<ul class="drop_down_content" v-show="showst==1">
							<li :class="lilist=='1-1'?'active':''"  @click="activeFun('1-1','')">· 我的產品</li>
						</ul>
					</div>
					<!-- 帳戶設定 -->
					<div class="drop_box drop_settlement drop_down_content"  @click="goLoginzx(2)">
						<div class="drop_down_title deoset_left" :class="lilist=='2'?'active':''">
							<img src="../../../assets/img/user/04my_product.png" alt="">開發設置
						</div>

					</div>
			
					<!-- drop_down_box -->
				</div>
				<!-- deal_left -->
			</div>
			<!-- 右边区块 -->
			<div class="deal_right">
				<router-view></router-view>
			</div>
			<!-- 内容 -->
		</div>
		<!-- deal_box -->
	</div>
</template>

<script>
	export default {
		name: 'platform',
		props: {},
		data() {
			return {
				userName: "這裡是商家簡稱",
				userId: 87775476,
				showst: sessionStorage.dropActive || 1,
				lilist: sessionStorage.numberactive || '1-1',
				
			}
		},
		components: {

		},
		methods: {
			downShows(index){
				this.showst=index
      			sessionStorage.dropActive = index;
			},
			goLoginzx(index) {
			  this.$router.push('/login/product/loginpdeve')
				this.lilist = index;
				this.showst=index;
				sessionStorage.dropActive = index;
				sessionStorage.numberactive = index;
			},
			
			activeFun(index, url){
				this.lilist = index;
				sessionStorage.numberactive = index;
			  this.$router.push('/login/product/'+url);
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/*  */
	.deal_box {
		background: #f3f3f3;
		overflow: hidden;
	}

	.cut_off {
		height: 4px;
		background: #e73262;
	}

	/*  */
	.deal_show_box {
		display: flex;

	}

	/* left */
	 .deal_left {
	  width: 220px;
	  min-width: 220px;
	  min-height: 700px;
	  background: #393857;
	  font-size: 13px;
	  color: #ffffff;
	}
	.deal_user {
	  box-sizing: border-box;
	  height: 264px;
	  font-size: 13px;
	  letter-spacing: 1px;
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  padding: 30px 0;
	}

	.deal_user .deal_user_photo {
		width: 140px;
		height: 140px;
		background: url("../../../assets/img/common/user_photo.png") center no-repeat;
		background-size: contain;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
	}

	.deal_user .deal_user_photo img {
		width: 25px;
		height: 25px;
	}

	.deal_user .deal_user_name {
		font-size: 15px;
		margin-top: 24px;
		margin-bottom: 10px;
	}

	/* 下拉菜单 */
	.drop_box {
		/* background: #30304c; */
		text-align: center;
		overflow: hidden;
		box-sizing: border-box;
	}

	.drop_active {
		background: #30304c;
	}

	.drop_down_title {
		cursor: pointer;
		box-sizing: border-box;
		font-size: 15px;
		margin-top: 15px;
	}

	.drop_down_hehi {
		margin-bottom: 0px;
	}

	.drop_down_title img {
		box-sizing: border-box;
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}

	.drop_down_title i {
		box-sizing: border-box;
		text-align: center;
		margin-left: 40px;
		width: 15px;
		height: 15px;
		

	}

	.drop_down_content li {
		font-size: 13px;
		padding: 8px 0;
		cursor: pointer;
	}

	.drop_down_content {
		padding-bottom: 8px;
	}

	.drop_down_content .active {
		border-right: 6px solid #e73262;
		color: #e73262;
		box-sizing: border-box;
	}

	.drop_down_content .last {
		margin-bottom: 8px;
	}

	/* right */
	.deal_right {
		width: 84.5vw;
	}

	/* 無下拉按鈕填充 */
	.deoset_left {
		padding-right: 55px;
	}

	.deoset_left_onr {
		padding-right: 45px;
	}
	
</style>
